import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const EventCarousel = ({ events = [] }) => {
  const featuredEvents = events.slice(0, 5);

  if (featuredEvents.length === 0) return null;

  return (
    <div className="w-full mb-10">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation={featuredEvents.length > 1}
        pagination={{
          clickable: true,
          dynamicBullets: featuredEvents.length > 3,
        }}
        autoplay={
          featuredEvents.length > 1
            ? {
                delay: 4000,
                disableOnInteraction: false,
              }
            : false
        }
        loop={featuredEvents.length > 1}
        className="rounded-xl overflow-hidden shadow-lg"
      >
        {featuredEvents.map((event) => (
          <SwiperSlide key={event.ref || event.eventId}>
            <Link to={`/event/${encodeURIComponent(event.ref)}`} className="block">
              <div className="relative w-full h-[250px] sm:h-[350px] lg:h-[420px] group">
                <img
                  src={event.banner || event.image}
                  alt={event.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/10 flex flex-col justify-end p-6 sm:p-10 text-white">
                  <span className="bg-yellow-400 text-black px-3 py-1 text-xs font-bold w-fit rounded-full">
                    {event.tag || "EVENT"}
                  </span>

                  <h2 className="text-xl sm:text-3xl lg:text-4xl font-semibold mt-3 max-w-[800px] leading-snug">
                    {event.title}
                  </h2>

                  <p className="text-sm mt-2 opacity-90">
                    {event.dateString}
                    {event.location ? ` · ${event.location}` : ""}
                  </p>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default EventCarousel;
